/**
 * Destination address for the avatar-menu "Report an issue" button.
 * Hosted as a constant rather than inline so it's easy to update without
 * touching the Header component.
 */
export const TECHNOLOGY_SUPPORT_EMAIL = 'technologysupport@medicallawservices.co.uk';
